export default "__VITE_ASSET__DhFZ9JkI__"